import type { ImageProps as NextImageProps } from "next/image";

export enum ImageSizes {
  "1x" = 16,
  "2x" = 24,
  "3x" = 32,
  "4x" = 40,
  "5x" = 48,
  "6x" = 56,
  "7x" = 64,
  "8x" = 72,
  "9x" = 80,
  "10x" = 88
}

interface ImageProps extends NextImageProps {
  loading?: "eager" | "lazy";
}

export default ImageProps;
